import Service from '@ember/service';

export default class PageLoaderUiService extends Service {
  topbar = document.getElementById('topbar');

  show() {
    if (this.topbar) this.topbar.style.display = 'block';
  }

  hide() {
    if (this.topbar) this.topbar.style.display = 'none';
  }
}
